import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FinancialYearAttachment } from '@contracts/interfaces/financial-year-summary.interface';
import { DateRange } from '@contracts/interfaces/transaction.interfaces';
import { TransactionStatementPeriodSummary } from '@contracts/interfaces/transaction-statement-summary.interface';
import { ConnectionService } from './connection.service';

interface TransactionStatementSummaryResponse {
  summary: TransactionStatementPeriodSummary | null;
}

@Injectable({
  providedIn: 'root'
})
export class TransactionStatementSummaryService {
  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService
  ) {}

  get(range: DateRange): Observable<TransactionStatementPeriodSummary | null> {
    return this.http.post<TransactionStatementSummaryResponse>(`${this.connectionService.address}/transaction-statement-summary-service/get`, {
      startDate: range.start,
      endDate: range.end
    }).pipe(map(res => res.summary || null));
  }

  update(summary: TransactionStatementPeriodSummary): Observable<TransactionStatementPeriodSummary> {
    return this.http.post<TransactionStatementSummaryResponse>(`${this.connectionService.address}/transaction-statement-summary-service/update`, { summary })
      .pipe(map(res => res.summary as TransactionStatementPeriodSummary));
  }

  uploadStatementCsv(range: DateRange, accountNumber: string, accountName: string, file: File): Observable<TransactionStatementPeriodSummary> {
    const formData = new FormData();
    formData.append('startDate', range.start.toISOString());
    formData.append('endDate', range.end.toISOString());
    formData.append('accountNumber', accountNumber);
    formData.append('accountName', accountName || accountNumber);
    formData.append('statement', file);

    return this.http.post<TransactionStatementSummaryResponse>(`${this.connectionService.address}/transaction-statement-summary-service/upload-statement`, formData)
      .pipe(map(res => res.summary as TransactionStatementPeriodSummary));
  }

  getStatementURL(statement: FinancialYearAttachment) {
    if (!statement?.file) {
      return '';
    }

    if (statement.file.storageKey && statement.file.storageKey.length > 0) {
      return `${this.connectionService.address}/${statement.file.path}/${statement.file.storageKey}`;
    }

    return `${this.connectionService.address}/${statement.file.path}/${statement.file.filename}`;
  }
}
